const ACTIVE_SUBSCRIBER_TAG = "Active Subscriber";

if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.CartDrawer = document.querySelector("cart-drawer");
        this.ShippingNotification = document.querySelector("shipping-notification");
        this.isFeaturedProduct = this.hasAttribute("data-is-featured-product");

        this.hasSubscription =
          this.hasAttribute("data-has-subscription") && this.getAttribute("data-has-subscription") === "true"
            ? true
            : false;
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        const submitButton = this.querySelector('[type="submit"]');
        const freeSubGiftElement = this.querySelector("[data-free-sub-gift]");
        const eligibleGiftVariantId =
          freeSubGiftElement && freeSubGiftElement.value !== "" ? freeSubGiftElement.value : null;
        let isActiveSubscriber = false;
        if (window.customerTags && window.customerTags.includes(ACTIVE_SUBSCRIBER_TAG)) {
          isActiveSubscriber = true;
        }

        if (submitButton.classList.contains("loading")) return;

        this.handleErrorMessage();

        this.CartDrawer.setActiveElement(document.activeElement);

        submitButton.setAttribute("aria-disabled", true);
        submitButton.classList.add("loading");
        this.querySelector(".loading-overlay__spinner").classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";

        const sectionsData = {
          sections: this.CartDrawer.getSectionsToRender().map((section) => section.section),
          sections_url: window.location.pathname,
        };

        let data = {
          ...JSON.parse(serializeForm(this.form)),
          ...sectionsData,
        };

        let copyData = data;
        // also check to make sure selling_plan is a number.
        const isSubscription = copyData.selling_plan !== "" && Number(copyData.selling_plan) !== 0;
        const isSubgiftInCart = document.body.classList.contains("subgift-in-cart");
        config.body = JSON.stringify(copyData);

        // Adds Free Sub Gift when all conditions are met
        if (isSubscription && eligibleGiftVariantId && !isActiveSubscriber && !isSubgiftInCart) {
          const formData = {
            items: [
              {
                id: copyData.id,
                quantity: copyData.quantity,
                selling_plan: copyData.selling_plan,
                properties: {
                  _eligibleFreeGift: eligibleGiftVariantId.toString(),
                  _excludeFromBundles: true,
                },
              },
              {
                id: eligibleGiftVariantId,
                quantity: 1,
                properties: {
                  _isFreeSubGift: true,
                },
              },
            ],
            ...sectionsData,
          };
          config.body = JSON.stringify(formData);
        }

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);
              return;
            }

            document.querySelector("cart-items")?.classList.toggle("is-empty", response.item_count === 0);
            document.getElementById("main-cart-items")?.classList.toggle("is-empty", response.item_count === 0);
            document.getElementById("main-cart-footer")?.classList.toggle("is-empty", response.item_count === 0);

            this.CartDrawer.renderContents(response);

            return fetch(`${routes.cart_change_url}`, config);
          })
          .then((cartResponse) => cartResponse.json())
          .then((cartResponse) => {
            this.ShippingNotification.updateShippingNotification(cartResponse.total_price);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            submitButton.classList.remove("loading");
            submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading-overlay__spinner").classList.add("hidden");
          });
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper");
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector(".product-form__error-message");

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
